import {
  Button,
  FormControlLabel,
  TextareaAutosize,
  styled,
} from '@mui/material';

export const StyledTextarea = styled(TextareaAutosize)(({ theme }) => ({
  width: '100%',
  resize: 'none',
  border: 'none',
  outline: 'none',
  padding: 0,
  ...theme.typography.body2,
  color: theme.palette.text.primary,
  backgroundColor: 'transparent',
  '&::placeholder': {
    color: theme.palette.text.disabled,
  },
}));

export const StyledActionsContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: theme.spacing(2),
  overflow: 'hidden',
}));

export const StyledActions = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}));

export const ToggleButton = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  borderRadius: theme.spacing(1),
  padding: theme.spacing(0.5, 1),
  border: `1px solid ${theme.palette.action.focus}`,
  color: theme.palette.text.secondary,
  lineHeight: theme.spacing(1),
  cursor: 'pointer',
  whiteSpace: 'nowrap',
  '& svg': {
    width: theme.spacing(2.25),
    height: theme.spacing(2.25),
  },
  '&.active': {
    backgroundColor: theme.palette.action.selected,
  },
  '&:hover:not(.active):not(.disable)': {
    backgroundColor: theme.palette.action.hover,
  },
  '&.context-icon-button': {
    cursor: 'default',
    '& .context-icon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 18,
    },
    '& .remove-icon': {
      color: theme.palette.error.main,
      display: 'none',
      cursor: 'pointer',
    },
    '&:hover': {
      '& .context-icon': {
        display: 'none',
      },
      '& .remove-icon': {
        display: 'flex',
      },
    },
  },
  '&.disable': {
    opacity: 0.5,
    cursor: 'default',
  },
}));

export const SubmitButton = styled(Button)(({ theme }) => ({
  minWidth: 'unset',
  border: `1px solid transparent`,
  padding: theme.spacing(0.75),
  margin: theme.spacing(0.25, 0),
  '&:hover': {
    boxShadow: 'none',
  },
}));

export const StyledFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  '& .MuiFormControlLabel-label': {
    ...theme.typography.caption,
    color: theme.palette.text.secondary,
  },
}));
